import { Container, Title, Text, Button, Group, Stack, Paper } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

interface Shift {
  id: string;
  date: string;
  clockInTime: string;
  workMode: 'remote' | 'office';
  breakMinutes: number;
  status: 'pending' | 'approved' | 'rejected';
}

export function StaffDashboard() {
  const navigate = useNavigate();
  const shifts: Shift[] = [
    {
      id: '1',
      date: '2024-03-20',
      clockInTime: '09:00',
      workMode: 'office',
      breakMinutes: 30,
      status: 'approved'
    },
    {
      id: '2',
      date: '2024-03-21',
      clockInTime: '10:00',
      workMode: 'remote',
      breakMinutes: 60,
      status: 'pending'
    }
  ];

  const getStatusColor = (status: Shift['status']) => {
    switch (status) {
      case 'approved':
        return 'green';
      case 'rejected':
        return 'red';
      default:
        return 'yellow';
    }
  };

  const handleClockIn = () => {
    navigate('/staff/clock-in');
  };

  return (
    <Container size="md" py="xl">
      <Stack gap="xl">
        <Group justify="space-between">
          <Title order={2}>スタッフダッシュボード</Title>
          <Button onClick={handleClockIn}>出勤する</Button>
        </Group>

        {shifts.map((shift) => (
          <Paper key={shift.id} p="md" withBorder>
            <Group justify="space-between">
              <Stack gap="xs">
                <Text size="lg" fw={500}>
                  {shift.date}
                </Text>
                <Text>
                  出勤時間: {shift.clockInTime}
                </Text>
                <Text>
                  勤務形態: {shift.workMode === 'remote' ? 'テレワーク' : '出社'}
                </Text>
                <Text>
                  休憩時間: {shift.breakMinutes}分
                </Text>
              </Stack>
              <Text color={getStatusColor(shift.status)} fw={500}>
                {shift.status}
              </Text>
            </Group>
          </Paper>
        ))}

        {shifts.length === 0 && (
          <Text ta="center" c="dimmed">
            打刻記録がありません
          </Text>
        )}
      </Stack>
    </Container>
  );
} 